import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import CheckBox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import axios from "axios";
import toastr from "toastr";

class SubmitOwnerModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {remarks: this.setRemarks()};
    this.SubmitAccessAPI = this.SubmitAccessAPI.bind(this);
  }

  setRemarks() {
    if(this.props.selectedOption==1)
      return "Approved";
    else
      return "";
  }

  setButton() {
    if(this.props.selectedOption==1)
      return "Approve";
    else if(this.props.selectedOption==2)
      return "Reject";
  }

  SubmitAccessAPI(data, recovery) {
    //Make the post API call
    //If Successful, close Modal & refresh Owner Applications
    //If Error occures, display Toast message
    let request = {
      "appAccessID":this.props.currentApplication.appAccessID,
      "vhPermission":this.props.currentApplication.vhPermission,
      "type":"owner",
      "ownerStatus": this.props.selectedOption,
      "ownerComments": this.state.remarks
    }
    //console.log(request);
    axios.post(process.env.REQ_URL+"/appaccess/updateApplicationAccess", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.props.close();
      this.props.refresh();
      toastr.success("Status updated");
    }).catch((err)=> {
      toastr.error("Error Occurred While Updating Status");
    });
  }

  render() {
    console.log(this.props.currentApplication);
    return (
      <Modal bsSize="small" show={this.props.open} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>Submit Owner Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Application Name: {this.props.currentApplication.appName}</p>
          <p>Employee Name: {this.props.currentApplication.empName} ({this.props.currentApplication.empID})</p>
          <p>Employee Manager Name: {this.props.currentApplication.managerName} ({this.props.currentApplication.managerEmpID})</p>
          <p>VH Name: {this.props.currentApplication.vhName} ({this.props.currentApplication.vhEmpID})</p>
          <TextField
            hintText="Enter Reason"
            floatingLabelText="Remarks"
            value={this.state.remarks}
            onKeyPress = {(target) => {if(target.charCode==13) $("#saveButton").click();}}
            onChange={(event)=> {
              this.setState({remarks: event.target.value})
            }}
          />
          <br/>
          <button
            id = "saveButton"
            disabled={this.state.remarks.length==0?true:false}
            onClick={this.SubmitAccessAPI}
            className="btn btn-default btn-block">{this.setButton()}
          </button>
          &nbsp;
        </Modal.Body>
      </Modal>
    );
  }
}

SubmitOwnerModal.propTypes = {};

export default SubmitOwnerModal;



/** WEBPACK FOOTER **
 ** ./src/feature/appAccess/myOwnerApplications/components/SubmitOwnerModal.js
 **/